import { api } from "./client";

export interface User {
  id: string;
  email: string;
  tier: "free" | "supporter" | "pro" | "enterprise";
  stripeCustomerId: string | null;
}

export function login(email: string, turnstileToken?: string) {
  return api<{ sent: boolean }>("/dashboard/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, turnstileToken }),
  });
}

export function verify(token: string) {
  return api<{ user: User }>("/dashboard/auth/verify", {
    method: "POST",
    body: JSON.stringify({ token }),
  });
}

export function logout() {
  return api<{ ok: boolean }>("/dashboard/auth/logout", {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function getMe() {
  return api<{ user: User }>("/dashboard/auth/me");
}
